export default "__VITE_ASSET__Bnl0UuDb__"